import plantUserListSaga from 'modules/PlantUser/saga/list';
import plantUserDetailsSaga from 'modules/PlantUser/saga/details';
import { SagaIterator } from 'redux-saga';
import { fork } from 'redux-saga/effects';

export default function* PlantUseraga(): SagaIterator {
  yield fork(plantUserListSaga);
  yield fork(plantUserDetailsSaga);
}
